import { useMemo, useCallback, createContext, useContext, useState } from 'react'

import { isValidFormData } from 'src/utils/form'

import { useLocalStorage } from '../useLocalStorage'

import { SchedulePostFormProps, SchedulePostFormProviderProps } from './types'
import { SCHEDULE_POST_FORM_DATA_KEY, INITIAL_FORM_DATA, FORM_VALIDATION } from './constants'

const SchedulePostFormContext = createContext<SchedulePostFormProps>({} as SchedulePostFormProps)

export const SchedulePostFormProvider = ({ children }: SchedulePostFormProviderProps) => {
  const [formData, setFormData] = useLocalStorage(SCHEDULE_POST_FORM_DATA_KEY, INITIAL_FORM_DATA)
  const [isScheduleFormSaved, setIsScheduleFormSaved] = useState<boolean>(false)

  const isSelectedOption = useCallback(
    (option: string) => formData.scheduledPubTimeZoneId === option || undefined,
    [formData.scheduledPubTimeZoneId]
  )

  const formIsInvalid = useMemo(() => !isValidFormData(formData, FORM_VALIDATION), [formData])

  const resetForm = (): void => {
    setFormData({ ...INITIAL_FORM_DATA })
    setIsScheduleFormSaved(false)
  }

  return (
    <SchedulePostFormContext.Provider
      value={{
        isSelectedOption,
        formIsInvalid,
        formData,
        isScheduleFormSaved,
        setIsScheduleFormSaved,
        setFormData,
        resetForm
      }}
    >
      {children}
    </SchedulePostFormContext.Provider>
  )
}

export const useSchedulePostForm = () => useContext(SchedulePostFormContext)
